import {getMerchantLU} from "../api";
const SET_MERCHANT_DETAILS = "setMerchantDetails";

const setMerchantDetails = (payload) => {
  return { type: SET_MERCHANT_DETAILS, payload };
};
const clearMerchantData=()=>{
  return { type: SET_MERCHANT_DETAILS, payload:{loader:false,data:null,error:""} };
}
const fetchMerchantDetailes = (userId) => {
  return async (dispatch) => {
    dispatch(
        setMerchantDetails({
          loader: true,
          data: null,
          error: "",
        })
      );
    try {
      const response = await getMerchantLU(userId);
      if (response.ok) {
        dispatch(
          setMerchantDetails({
            loader: false,
            data: response?.data,
            error: "",
          })
        );
      } else {
        dispatch(
          setMerchantDetails({
            loader: false,
            data: null,
            error: response.originalError.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        setMerchantDetails({
          loader: false,
          data: null,
          error: error,
        })
      );
    }
  };
}


let initialState = { 
  merchants: { loader: true, data: null, error: "" },
};
const DashboardMerchantReducer = (state, action) => {
  state = state || initialState;
  switch (action.type) {
    case SET_MERCHANT_DETAILS:
      state = {
        ...state,
        merchants: {
          ...action.payload,
        },
      };
      return state;
      default :
      return state;
  }
};
export default DashboardMerchantReducer;
export { fetchMerchantDetailes ,setMerchantDetails,clearMerchantData};
